import { FlexColumn, FlexRow } from "designSystem/index";
import PaneHeader from "designSystem/components/pane/PaneHeader";
import { observer } from "mobx-react-lite";
import React from "react";
import ChannelForm from "src/Chat/component/ChannelForm";
import { useMSTeamsStore } from "./MSTeamsStore";

const AddChannel: React.FunctionComponent = observer(() => {
	const store = useMSTeamsStore();
	const {
		closeRightPane,
		navigationToChannelSelection,
		readyToCreateChannel,
	} = store;

	return (
		<FlexColumn>
			<FlexRow>
				<PaneHeader
					back
					onBack={navigationToChannelSelection}
					onClose={closeRightPane}
					titleRes="AddNewChannelTitle"
				/>
			</FlexRow>
			<ChannelForm
				dataReady={readyToCreateChannel}
				store={store}
			/>
		</FlexColumn>
	);
});

export default AddChannel;